import * as React from 'react';

export const Facebook: React.SFC<{}> = () => {
  return (
    <svg width="9" height="18" viewBox="0 0 9 18" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.456 17.586H1.818V8.793H0V5.762H1.818V3.943C1.818 1.472 2.845 0 5.76 0H8.188V3.031H6.671C5.536 3.031 5.46 3.455 5.46 4.245L5.456 5.762H8.206L7.884 8.793H5.456V17.586Z"
        fill="white"
      />
    </svg>
  );
};
